import React from 'react'
import { MenuItem, Select } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { Filter } from 'components/search'

export default function Filters({ searchState, setSearchState }) {
  const { access, division, programStatus, radius } = searchState

  const setAccess = access => setSearchState({ access })
  const setDivision = division => setSearchState({ division })
  const setProgramStatus = programStatus => setSearchState({ programStatus })
  const setRadius = radius => setSearchState({ radius })

  return (
    <>
      <Filter>
        <Select
          id="radius"
          value={radius}
          variant="outlined"
          onChange={e => setRadius(e.target.value)}
          IconComponent={KeyboardArrowDownIcon}
        >
          <MenuItem value="any">Any distance</MenuItem>
          <MenuItem value={10}>10 miles</MenuItem>
          <MenuItem value={25}>25 miles</MenuItem>
          <MenuItem value={50}>50 miles</MenuItem>
        </Select>
      </Filter>

      <Filter>
        <Select
          id="division"
          displayEmpty
          variant="outlined"
          value={division}
          IconComponent={KeyboardArrowDownIcon}
          onChange={e => setDivision(e.target.value)}
        >
          <MenuItem value="">Any Age Division</MenuItem>
          <MenuItem value="JRL_13U">13U</MenuItem>
          <MenuItem value="JRL_17U">17U</MenuItem>
        </Select>
      </Filter>

      <Filter>
        <Select
          id="access"
          displayEmpty
          variant="outlined"
          value={access}
          IconComponent={KeyboardArrowDownIcon}
          onChange={e => setAccess(e.target.value)}
        >
          <MenuItem value="">All Access Types</MenuItem>
          <MenuItem value="OPEN_TO_PUBLIC">Open Registration</MenuItem>
          <MenuItem value="CODE_REQUIRED">Access Code Required</MenuItem>
          <MenuItem value="CLUB_REQUIRED">Club Membership Required</MenuItem>
        </Select>
      </Filter>

      <Filter item md={2} sm={12} xs={12}>
        <Select
          id="program-status"
          displayEmpty
          variant="outlined"
          value={programStatus}
          IconComponent={KeyboardArrowDownIcon}
          onChange={e => setProgramStatus(e.target.value)}
        >
          <MenuItem value="">Any Program Type</MenuItem>
          <MenuItem value="open">Open and Upcoming programs</MenuItem>
        </Select>
      </Filter>
    </>
  )
}
